import pegasus from "./01-pegasus";

window.setTabItemHeights = () => {
    const tabContainer = document.querySelectorAll('.tabbed-content');

    if (!tabContainer || !tabContainer.length) {
        return;
    }

    tabContainer.forEach((container) => {
        const tabItems = container.querySelectorAll('.TabItem');
        let maxHeight = 0;

        const hiddenStates = [];

        tabItems.forEach((item) => {
            item.style.height = 'auto';
            const pegasusContainer = item.querySelector('.Pegasus__Container');
            if (pegasusContainer) {
                pegasusContainer.style.height = 'auto';
            }

            const innerContent = item.querySelector('[x-show]');

            if (innerContent) {
                const currentDisplay = innerContent.style.display;
                const wasHidden = window.getComputedStyle(innerContent).display === 'none';

                hiddenStates.push({ innerContent, currentDisplay, wasHidden });

                if (wasHidden) {
                    innerContent.style.setProperty('display', 'block', 'important');
                    innerContent.style.visibility = 'hidden';
                    innerContent.style.pointerEvents = 'none';
                }
            }
        });

        requestAnimationFrame(() => {
            tabItems.forEach((item) => {
                const pegasusContainer = item.querySelector('.Pegasus__Container');
                const itemHeight = pegasusContainer ? pegasusContainer.offsetHeight : item.offsetHeight;

                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                }
            });

            if (maxHeight > 0) {
                tabItems.forEach((item) => {
                    const pegasusContainer = item.querySelector('.Pegasus__Container');
                    if (pegasusContainer) {
                        pegasusContainer.style.height = `${maxHeight}px`;
                    }
                });
            }

            hiddenStates.forEach(({ innerContent, currentDisplay, wasHidden }) => {
                if (wasHidden) {
                    innerContent.style.display = currentDisplay;
                    innerContent.style.visibility = '';
                    innerContent.style.pointerEvents = '';
                }
            });
        });
    });
};

window.setGridItemHeights = () => {
    const gridContainers = document.querySelectorAll('.destination-details-grid');

    if (!gridContainers || !gridContainers.length) {
        return;
    }

    gridContainers.forEach((container) => {
        // Get the grid wrapper and then its direct children (the white cards)
        const gridWrapper = container.querySelector('.wp-block-group.is-layout-grid');
        if (!gridWrapper) return;

        const gridItems = gridWrapper.querySelectorAll(':scope > .wp-block-group');
        let maxHeight = 0;

        // Reset heights first
        gridItems.forEach((item) => {
            item.style.height = 'auto';
        });

        requestAnimationFrame(() => {
            // Find maximum height
            gridItems.forEach((item) => {
                const itemHeight = item.offsetHeight;
                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                }
            });

            // Apply maximum height to all items
            if (maxHeight > 0) {
                gridItems.forEach((item) => {
                    item.style.height = `${maxHeight}px`;
                });
            }
        });
    });
};

window.setLargeSliderHeight = () => {
    const sliderContainers = document.querySelectorAll('.large-post-slider');

    if (!sliderContainers || !sliderContainers.length) {
        return;
    }

    sliderContainers.forEach((container) => {
        // Get all slide elements within the carousel
        const slides = container.querySelectorAll('.slide');
        if (!slides || !slides.length) return;

        let maxHeight = 0;

        // Reset heights first
        slides.forEach((slide) => {
            slide.style.height = 'auto';
        });

        requestAnimationFrame(() => {
            // Find maximum height
            slides.forEach((slide) => {
                const slideHeight = slide.offsetHeight;
                if (slideHeight > maxHeight) {
                    maxHeight = slideHeight;
                }
            });

            // Apply maximum height to all slides
            if (maxHeight > 0) {
                slides.forEach((slide) => {
                    slide.style.height = `${maxHeight}px`;
                });
            }
        });
    });
};

window.setOfferSliderHeight = () => {
    const sliderContainers = document.querySelectorAll('.slider-container.single_offer');

    if (!sliderContainers || !sliderContainers.length) {
        return;
    }

    sliderContainers.forEach((container) => {
        // Get all Post__Grid-post elements (the actual content cards)
        const cards = container.querySelectorAll('.Post__Grid-post');
        const carousel = container.querySelector('.Carousel');

        if (!cards || !cards.length) return;

        let maxHeight = 0;

        // Reset all card heights first
        cards.forEach((card) => {
            card.style.height = 'auto';
            card.style.minHeight = 'auto';
            // Also reset the inner group element
            const group = card.querySelector('.group');
            if (group) {
                group.style.height = 'auto';
                group.style.minHeight = 'auto';
            }
        });

        requestAnimationFrame(() => {
            // Measure each card to find the tallest
            cards.forEach((card) => {
                const height = card.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            // Apply maximum height to all cards AND their parent slides
            if (maxHeight > 0) {
                cards.forEach((card) => {
                    card.style.minHeight = `${maxHeight}px`;
                    card.style.height = `${maxHeight}px`;

                    // Set height on the inner group element to fill the card
                    const group = card.querySelector('.group');
                    if (group) {
                        group.style.height = '100%';
                        group.style.minHeight = '100%';
                    }

                    // Also set the parent slide height
                    const slide = card.closest('.slide.single_offer');
                    if (slide) {
                        slide.style.minHeight = `${maxHeight}px`;
                        slide.style.height = `${maxHeight}px`;
                    }
                });

                // Set the carousel container height to match
                if (carousel) {
                    carousel.style.height = `${maxHeight}px`;
                }
            }
        });
    });
};

window.setTestimonialCarouselHeight = () => {
    const testimonialCarousels = document.querySelectorAll('.Testimonial__Carousel .Content__Carousel.-single-slide');

    if (!testimonialCarousels || !testimonialCarousels.length) {
        return;
    }

    testimonialCarousels.forEach((carouselRoot) => {
        const carousel = carouselRoot.querySelector('.Carousel');

        if (!carousel) {
            return;
        }

        const slides = Array.from(carousel.children).filter((child) => child.nodeType === 1);

        if (!slides.length) {
            return;
        }

        const hiddenStates = [];
        let maxHeight = 0;

        carousel.style.height = 'auto';

        slides.forEach((slide) => {
            slide.style.height = 'auto';
            slide.style.minHeight = 'auto';

            const computedDisplay = window.getComputedStyle(slide).display;

            if (computedDisplay === 'none') {
                hiddenStates.push({
                    slide,
                    display: slide.style.display,
                    visibility: slide.style.visibility,
                    pointerEvents: slide.style.pointerEvents,
                });

                slide.style.display = 'block';
                slide.style.visibility = 'hidden';
                slide.style.pointerEvents = 'none';
            }
        });

        slides.forEach((slide) => {
            const slideHeight = slide.offsetHeight;

            if (slideHeight > maxHeight) {
                maxHeight = slideHeight;
            }
        });

        hiddenStates.forEach(({ slide, display, visibility, pointerEvents }) => {
            slide.style.display = display;
            slide.style.visibility = visibility;
            slide.style.pointerEvents = pointerEvents;
        });

        if (maxHeight > 0) {
            carousel.style.height = `${maxHeight}px`;

            slides.forEach((slide) => {
                slide.style.minHeight = `${maxHeight}px`;
            });
        }

        const images = carousel.querySelectorAll('img');

        images.forEach((image) => {
            if (image.dataset.testimonialCarouselHeightBound === 'true') {
                return;
            }

            image.addEventListener('load', () => {
                window.setTestimonialCarouselHeight();
            });

            image.dataset.testimonialCarouselHeightBound = 'true';
        });
    });
};

window.initFooterLinkColumns = () => {
    const footer = document.querySelector(".footer-container");

    if (!footer) {
        return;
    }

    const footerLinkColumns = footer.querySelectorAll(".footer-link-column");

    if (!footerLinkColumns || !footerLinkColumns.length) {
        return;
    }

    const setupCollapsible = (column) => {
        const headings = column.querySelectorAll(".wp-block-heading");
        if (!headings) {
            return;
        }

        const getLinkHeight = (group) => {
            const links = group.querySelectorAll("p");
            let height = 0;
            links.forEach((link) => {
                const style = window.getComputedStyle(link);
                height += link.offsetHeight;
                height += parseInt(style.marginBottom);
            });
            return height;
        };

        headings.forEach((heading) => {
            const group = heading.nextElementSibling;

            // Remove any existing click handlers by cloning and replacing the element's event listeners
            // But preserve the original DOM element to maintain editor connectivity
            const clickHandlerExists = heading.hasAttribute('data-click-handler');

            group.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
            group.style.overflow = 'hidden';
            group.style.height = window.innerWidth >= 782 ? 'auto' : '0px';
            heading.classList.remove('-open');

            if (window.innerWidth < 782) {
                // Only add click handler if it doesn't already exist
                if (!clickHandlerExists) {
                    const clickHandler = (e) => {
                        const height = getLinkHeight(group);
                        if (heading.classList.contains("-open")) {
                            group.style.height = height + "px";
                            requestAnimationFrame(() => {
                                group.style.height = "0px";
                                heading.classList.remove("-open");
                            });
                        } else {
                            group.style.height = "0px";
                            requestAnimationFrame(() => {
                                group.style.height = height + "px";
                                heading.classList.add("-open");
                            });
                        }
                    };

                    // Store the handler reference for later removal
                    heading.clickHandler = clickHandler;
                    heading.addEventListener("click", clickHandler);
                    heading.setAttribute('data-click-handler', 'true');
                }
            } else {
                group.style.transition = '';
                group.style.overflow = '';
                // Remove click handler for desktop without DOM replacement
                if (clickHandlerExists) {
                    heading.removeEventListener("click", heading.clickHandler);
                    heading.removeAttribute('data-click-handler');
                    delete heading.clickHandler;
                }
            }
        });
    };

    footerLinkColumns.forEach(setupCollapsible);
};

window.setResourceSubnavCurrentPageState = () => {
    const linkGroups = document.querySelectorAll('.Resource__Subnav .Link__Group');

    if (!linkGroups.length) {
        return;
    }

    const normalizeUrl = (value) => {
        try {
            const url = new URL(value, window.location.origin);

            if (!['http:', 'https:'].includes(url.protocol)) {
                return null;
            }

            const path = url.pathname.replace(/\/+$/, '') || '/';
            return `${url.origin}${path}`;
        } catch {
            return null;
        }
    };

    const currentUrl = normalizeUrl(window.location.href);

    if (!currentUrl) {
        return;
    }

    linkGroups.forEach((group) => {
        const link = group.matches('a[href]') ? group : group.querySelector('a[href]');

        if (!link) {
            group.classList.remove('is-current-page');
            return;
        }

        const href = link.getAttribute('href');

        if (!href || href === '#' || href.startsWith('#')) {
            group.classList.remove('is-current-page');
            return;
        }

        const linkUrl = normalizeUrl(href);
        group.classList.toggle('is-current-page', linkUrl === currentUrl);
    });
};


// --- Pegasus Button Copy Page URL Handler ---

function pegasusCopyPageUrlHandler(e) {
    e.preventDefault();
    if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
    } else {
        // fallback for older browsers
        var textarea = document.createElement('textarea');
        textarea.value = window.location.href;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    // Show a small tooltip near the button
    var btn = e.currentTarget;
    var tooltip = document.createElement('span');
    tooltip.textContent = 'Copied!';
    tooltip.style.position = 'absolute';
    tooltip.style.background = 'rgba(30,30,30,0.95)';
    tooltip.style.color = '#fff';
    tooltip.style.fontSize = '13px';
    tooltip.style.padding = '3px 10px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)';
    tooltip.style.zIndex = 9999;
    tooltip.style.pointerEvents = 'none';
    tooltip.style.transition = 'opacity 0.2s';
    tooltip.style.opacity = '1';

    // Position: above or below button depending on space
    var rect = btn.getBoundingClientRect();
    var scrollY = window.scrollY || window.pageYOffset;
    var scrollX = window.scrollX || window.pageXOffset;
    document.body.appendChild(tooltip);
    // Default: above
    tooltip.style.left = (rect.left + scrollX + rect.width/2 - tooltip.offsetWidth/2) + 'px';
    tooltip.style.top = (rect.top + scrollY - tooltip.offsetHeight - 8) + 'px';
    // If not enough space above, show below
    if (rect.top < tooltip.offsetHeight + 12) {
        tooltip.style.top = (rect.bottom + scrollY + 8) + 'px';
    }

    setTimeout(function() {
        tooltip.style.opacity = '0';
        setTimeout(function() {
            if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
        }, 200);
    }, 1200);
}

function attachPegasusCopyUrlHandlers() {
    var buttons = document.querySelectorAll('[data-pegasus-copy-url]');
    buttons.forEach(function (btn) {
        btn.removeEventListener('click', pegasusCopyPageUrlHandler);
        btn.addEventListener('click', pegasusCopyPageUrlHandler);
    });
}

document.addEventListener('DOMContentLoaded', attachPegasusCopyUrlHandlers);
document.addEventListener('DOMContentLoaded', window.setResourceSubnavCurrentPageState);
if (typeof wp !== 'undefined' && wp.domReady) {
    wp.domReady(attachPegasusCopyUrlHandlers);
    wp.domReady(window.setResourceSubnavCurrentPageState);
}
if (typeof wp !== 'undefined' && wp.hooks) {
    wp.hooks.addAction('blocks.renderBlock', 'pegasus/copy-url', attachPegasusCopyUrlHandlers);
    wp.hooks.addAction('blocks.renderBlock', 'pegasus/resource-subnav-current-page', window.setResourceSubnavCurrentPageState);
}


// --- Remove Sidebar Logic ---
function handleSidebarVisibility() {
    // Assumes <body data-remove-sidebar="true|false">
    const body = document.body;
    if (!body) return;
    let removeSidebar = body.getAttribute('data-remove-sidebar');
    if (removeSidebar === null) return;
    // Normalize value to boolean
    removeSidebar = (removeSidebar === 'true' || removeSidebar === 1 || removeSidebar === true);

    const sidebar = document.querySelector('.post-content-sidebar');
    const noSidebar = document.querySelector('.post-content-no-sidebar');

    if (removeSidebar) {
        if (sidebar) sidebar.style.display = 'none';
        if (noSidebar) noSidebar.style.display = '';
    } else {
        if (sidebar) sidebar.style.display = '';
        if (noSidebar) noSidebar.style.display = 'none';
    }
}

// Initialize on load
window.onload = () => {
    window.initFooterLinkColumns();
    if (window.innerWidth >= 640) {
        window.setTabItemHeights();
        window.setGridItemHeights();
        window.setLargeSliderHeight();
    }
    // Call offer slider height on all screen sizes including mobile
    window.setOfferSliderHeight();
    window.setTestimonialCarouselHeight();
    // Attach copy url handlers in case blocks are rendered late
    attachPegasusCopyUrlHandlers();
    window.setResourceSubnavCurrentPageState();
    // Handle sidebar visibility
    handleSidebarVisibility();
};

// Also run sidebar logic on DOMContentLoaded in case scripts are loaded late
document.addEventListener('DOMContentLoaded', handleSidebarVisibility);
document.addEventListener('DOMContentLoaded', () => {
    window.setTestimonialCarouselHeight();
    setTimeout(window.setTestimonialCarouselHeight, 250);
});

// Handle resize events
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        window.initFooterLinkColumns();
        if (window.innerWidth >= 640) {
            window.setTabItemHeights();
            window.setGridItemHeights();
            window.setLargeSliderHeight();
        }
        // Call offer slider height on all screen sizes including mobile
        window.setOfferSliderHeight();
        window.setTestimonialCarouselHeight();
        // Re-handle sidebar visibility in case of dynamic content
        handleSidebarVisibility();
    }, 250);
});

// --- HubSpot Iframe Height Fix --- //
function setHubspotIframeMaxHeight(context = document) {
    // Select all HubSpot iframes in the given context (default: document)
    const hsFrames = context.querySelectorAll('.request-a-quote .hs-form-frame iframe');
    if (!hsFrames.length) return;

    hsFrames.forEach(hsFrame => {
        hsFrame.style.height = '100%';
        hsFrame.style.minHeight = '600px';
        hsFrame.style.maxHeight = 'none';
        hsFrame.setAttribute('scrolling', 'yes');
    });
}

// Set height on DOMContentLoaded and after a short delay (in case iframe loads late)
document.addEventListener('DOMContentLoaded', () => {
    setHubspotIframeMaxHeight();
    setTimeout(setHubspotIframeMaxHeight, 1200);
});

// Listen for the custom 'modalopen' event and set iframe height in the opened modal
window.addEventListener('modalopen', (e) => {
    const modalID = e.detail && e.detail.modalID;
    if (!modalID) return;
    const modal = document.getElementById(modalID);
    if (!modal) return;
    // Wait for modal content to be loaded
    setTimeout(() => setHubspotIframeMaxHeight(modal), 500);
});

// Also expose for manual use if needed
window.setHubspotIframeMaxHeight = setHubspotIframeMaxHeight;
